import { ref, useContext } from '@nuxtjs/composition-api'
import useDownload from './useDownload'
import _get from 'lodash/get'

export default function useDocumentsDownload(documentType = 'course') {
  const { store = {} } = useContext()
  const isDownloadingDocument = ref(false)
  const school = _get(store, 'state.settings.school')
  const activeCatalog = _get(store, 'state.settings.activeCatalog')

  const { download } = useDownload()

  async function downloadDocument(documentId) {
    if (!school || !activeCatalog || !documentId) return
    const downloadPdfUrl = `/ca/${school}/catalogs/${activeCatalog}/${documentType}s/${documentId}/pdf`

    try {
      isDownloadingDocument.value = true
      await download({
        url: downloadPdfUrl,
        filename: `${documentType}-${documentId}.pdf`,
      })
    } catch (e) {
      console.error(e)
    } finally {
      setTimeout(() => {
        isDownloadingDocument.value = false
      }, 200)
    }
  }

  return {
    downloadDocument,
    isDownloadingDocument,
  }
}
